import MainTable, { MainTableColumn } from '@/components/company/table/MainTable';
import { IJobDescription, IJobDescriptionPaginatedResponse } from '@/states/job.state';
import useKeyActivityState from '@/states/key-activities.state';
import { DataConfig } from '@/utils/hooks/useDefaultDataConfig';

interface JobDescriptionTableProps {
  isLoading: boolean;
  paginatedData: IJobDescriptionPaginatedResponse;
  pageConfig: DataConfig;
  setPageConfig: React.Dispatch<React.SetStateAction<DataConfig>>;
  onEdit: (row: IJobDescription) => void;
  onDelete: (row: IJobDescription) => void;
}

export default function JobDescriptionTable({
  isLoading,
  paginatedData,
  pageConfig,
  setPageConfig,
  onEdit,
  onDelete,
}: JobDescriptionTableProps) {
  const { keyActivities } = useKeyActivityState();

  const columns: MainTableColumn[] = [
    {
      name: 'org_chart_node.name',
      label: 'Role',
      render: (_: unknown, row: IJobDescription) => row?.org_chart_node?.name ?? '-',
    },
    {
      name: 'org_key_activity_id',
      label: 'Key Activities',
      render: (_: unknown, row) => keyActivities.find(ka => ka.id === row.org_key_activity_id)?.name ?? '-',
    },
    { name: 'name', label: 'Jobdesc' },
    { name: 'frequency', label: 'Frequency' },
    { name: 'report', label: 'Report' },
    { name: 'kpi', label: 'KPI' },
    {
      name: 'kpi_measurement',
      label: 'Measurement',
      render: (val: string) => <div className="max-w-xs truncate" dangerouslySetInnerHTML={{ __html: val || '-' }} />,
    },
    {
      name: 'is_published',
      label: 'Publish',
      render: (val: boolean) =>
        val ? (
          <span className="text-green-700 bg-green-100 border inline-block border-green-300 px-2 rounded-lg">
            Published
          </span>
        ) : (
          <span className="text-red-700 bg-red-100 border inline-block border-red-300 px-2 rounded-lg">
            Unpublished
          </span>
        ),
    },
  ];

  return (
    <MainTable
      showHeader={false}
      isLoading={isLoading}
      data={{
        content: paginatedData.content as unknown as { [key: string]: unknown }[],
        totalElements: paginatedData.totalElements,
        totalPages: paginatedData.totalPages,
      }}
      columns={columns}
      pageConfig={pageConfig}
      setPageConfig={setPageConfig}
      onEdit={(row: IJobDescription) => onEdit(row)}
      onDelete={(row: IJobDescription) => onDelete(row)}
      showActions
      useConfirmDelete={true}
    />
  );
}
